import { createFileRoute } from '@tanstack/react-router'

import { WatchesScreen } from '@/features/watches/watches-screen'

/** Every watch with its last and next run, and the run log. */
export const Route = createFileRoute('/_app/platform/watches')({
  component: WatchesScreen,
})
